module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraLight.570a244c.ttf";